export const ADD_QUEUED_CLAIMS = "ADD_QUEUED_CLAIMS";

export function addQueudedClaims(claims) {
  return {
    type: ADD_QUEUED_CLAIMS,
    payload: claims
  };
}




// WEBPACK FOOTER //
// ./src/app/submit_claims/claims_table/actions.js